import { WithPopover } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import LifecycleMenu from './components/LifecycleMenu';
import LifecyclePill from './components/LifecyclePill';
import { TEST_ID } from './constants';
import type { FunctionComponent, LifecycleLabelMap, Props } from './types';

import styles from './styles.module.scss';

const LifecycleControl: FunctionComponent<Props> = ({
    className = '',
    droneId,
    isAdmin,
    onSetLifecycle,
    status,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const lifecycleLabels: LifecycleLabelMap = {
        claimed: t.STATUS_CLAIMED,
        disabled: t.STATUS_DISABLED,
        enabled: t.STATUS_ENABLED,
        released: t.STATUS_RELEASED
    };
    // 'enabled'/'disabled' are data-only states: the pill renders read-only for them
    // and the claim/release menu only opens on the settable states.
    const isSettable = status === 'claimed' || status === 'released';
    const handleStop = (clickEvent: { stopPropagation: VoidFunction }) =>
        clickEvent.stopPropagation();
    const pill = <LifecyclePill label={lifecycleLabels[status]} status={status} />;

    return (
        <div
            className={`${styles.lifecycleControl} ${className}`}
            data-testid={testId}
            onClick={handleStop}>
            {isAdmin && isSettable ? (
                <WithPopover className={styles.popover} trigger={pill}>
                    <LifecycleMenu
                        lifecycleLabels={lifecycleLabels}
                        onSelect={selected => onSetLifecycle({ droneId, status: selected })}
                    />
                </WithPopover>
            ) : (
                pill
            )}
        </div>
    );
};

export default LifecycleControl;
